import { getUserId } from "@/utils/hooks/useOneTimeExecution";

const shouldShowHighValueOther = async () => {
  const today = new Date().toISOString().split("T")[0];
  const userId = await getUserId();
  const storageKey = `highValueOtherLastShow_${userId}`;

  const lastShowDate = localStorage.getItem(storageKey);

  if (!lastShowDate || lastShowDate !== today) {
    return true;
  }

  return false;
};

const updateShowHighValueOther = async () => {
  const today = new Date().toISOString().split("T")[0];
  const userId = await getUserId();
  const storageKey = `highValueOtherLastShow_${userId}`;

  const lastShowDate = localStorage.getItem(storageKey);

  if (!lastShowDate || lastShowDate !== today) {
    localStorage.setItem(storageKey, today);
  }
};

export { shouldShowHighValueOther, updateShowHighValueOther };
